var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.043 2h21.412L27.5 2a1.78 1.78 0 0 1 .12.02c.702.146.702.73.702 1.076v5.721c0 .73-.244 1.461-.852 1.948l-7.061 7.061 7.425 7.304c1.096 1.096 1.096 2.922 0 4.018-.487.608-1.218.852-1.948.852-.73 0-1.34-.365-1.948-.852l-9.497-9.496c-.608-.487-.852-1.217-.852-1.948.001-.73.366-1.46.853-1.948l7.858-8.278H8.6V27.2c0 1.583-1.217 2.8-2.8 2.8S3 28.783 3 27.2V5.043C3 3.34 4.217 2 6.043 2z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReq);
export default __webpack_public_path__ + "static/media/REQ.770fc23dd514b906c299bc0691161c5e.svg";
export { ForwardRef as ReactComponent };